import { msg } from '@lingui/macro'

import * as React from 'react'

import { useTrans } from '~logic/i18n/useTrans'
import { TwoLiner } from '~ui/components/typography/TwoLiner/TwoLiner'

import { formatAddress } from '../../../helpers/formatAddress'
import { useFormOrderCtx } from '../contexts/FormOrderProvider'

type TProps = NoChildren

/**
 * Order place with label as presented on FormScreen.
 */
export const FormOrderPlace: React.FC<TProps> = () => {
  const { trans } = useTrans()
  const formOrder = useFormOrderCtx()

  const getLabel = () => {
    if (!formOrder) {
      return `placeholder`
    }

    if (formOrder.handoverType?.enum === `PICKUP`) {
      return msg({
        id: `pick-up-at.place`,
        message: `pick up at`,
        comment: 'pick up at (place)',
      })
    }

    if (formOrder.handoverType?.enum === `MESSENGER`) {
      return msg`we will deliver to`
    }

    return msg`place`
  }

  const getValue = () => {
    if (!formOrder) {
      return `longer placeholder`
    }

    return formatAddress(formOrder.handoverAddress)
  }

  const labelValue = getLabel()
  const label = typeof labelValue === `string` ? labelValue : trans(labelValue)

  return (
    <TwoLiner
      label={label}
      value={getValue()}
      showSkeleton={!formOrder}
      alignItems={`flex-start`}
    />
  )
}
